import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { SelectedVoteRound } from './SelectedVoteRound';
import { VoteRound } from './VoteRound';

export const resolveActiveVoteRound = (objects: ObjectManager, session: EditorSession) => {
    const selectedRound = session.get(SelectedVoteRound);
    if (selectedRound) {
        // Use find because it might not exist
        const result = objects.find(x => x.id === selectedRound);
        if (result && result.alive && result instanceof VoteRound) return result;
    }
    return selectLatestVoteRound(objects.getAll(VoteRound));
};

export const getLatestVoteRound = (objects: ObjectManager) => selectLatestVoteRound(objects.getAll(VoteRound));

export const selectLatestVoteRound = (voteRounds: Iterable<VoteRound>) => {
    // When selecting the latest, account for the possibility of duplicate index values and fallback to id comparison to ensure behavior is
    // consistent across clients.
    let r = null as VoteRound;
    for (const vr of voteRounds) {
        if (!vr.alive) continue;
        if (r && vr.index < r.index) continue;
        if (r && vr.index === r.index && vr.id < r.id) continue;
        r = vr;
    }
    return r;
};
